import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import './Pages.css';

function AboutCompany() {
  const { t } = useTranslation();

  return (
    <div className="main-bg">
      <Header />
      <div className="page-container">
        <div className="page-header">
          <h1>{t('about.title')}</h1>
          <div className="page-bar"></div>
        </div>
        
        <div className="page-content">
          <div className="about-detail">
            <div className="about-description">
              <h2>Historia Jonë</h2>
              <p>ShalaAccounting u themelua me qëllimin e ofrimit të shërbimeve më cilësore në fushën e kontabilitetit dhe konsulencës biznesi në Kosovë. Me më shumë se 15 vjet përvojë, ekipi ynë i ekspertëve ka ndihmuar qindra biznese të zhvillohen dhe të rriten.</p>
              
              <h2>Misioni Ynë</h2>
              <p>Misioni ynë është të ofrojmë zgjidhje gjithëpërfshirëse kontabiliteti dhe konsulencë biznesi të dizajnuara për suksesin e klientëve tanë. Ne besojmë në integritet, transparencë dhe ekselencë në çdo aspekt të punës sonë.</p>
              
              <h2>Vizioni Ynë</h2>
              <p>Dëshirojmë të jemi partneri i besueshëm për zhvillimin e biznesit në Kosovë, duke ofruar shërbime profesionale që kontribuojnë në rritjen ekonomike dhe zhvillimin e komunitetit.</p>
            </div>
            
            <div className="company-values">
              <h2>Vlerat Tona</h2>
              <div className="values-grid">
                <div className="value-card">
                  <h3>Integriteti</h3>
                  <p>Veprojmë me ndershmëri dhe etikë profesionale në çdo marrëdhënie</p>
                </div>
                <div className="value-card">
                  <h3>Ekselenca</h3>
                  <p>Kërkojmë cilësinë më të lartë në çdo shërbim që ofrojmë</p>
                </div>
                <div className="value-card">
                  <h3>Inovacioni</h3>
                  <p>Përdorim teknologjitë më të fundit për rezultate më të mira</p>
                </div>
                <div className="value-card">
                  <h3>Bashkëpunimi</h3>
                  <p>Punojmë së bashku me klientët për të arritur objektivat e tyre</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default AboutCompany; 